var _ = Object.defineProperty, $ = Object.defineProperties;
var z = Object.getOwnPropertyDescriptors;
var l = Object.getOwnPropertySymbols;
var T = Object.prototype.hasOwnProperty, w = Object.prototype.propertyIsEnumerable;
var y = (e, n, t) => n in e ? _(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, B = (e, n) => {
  for (var t in n || (n = {}))
    T.call(n, t) && y(e, t, n[t]);
  if (l)
    for (var t of l(n))
      w.call(n, t) && y(e, t, n[t]);
  return e;
}, C = (e, n) => $(e, z(n));
var N = (e, n) => {
  var t = {};
  for (var r in e)
    T.call(e, r) && n.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && l)
    for (var r of l(e))
      n.indexOf(r) < 0 && w.call(e, r) && (t[r] = e[r]);
  return t;
};
import { jsxs as v, jsx as m } from "react/jsx-runtime";
import o from "../../../node_modules/prop-types/index.es.js";
import { useState as x, useEffect as u } from "react";
import * as D from "./style.es.js";
import { SegmentedButton as G, SegmentedButtonTab as J, SegmentedButtonTabItem as K, SegmentedButtonContent as Q } from "./style.es.js";
import { Button as U } from "../../Inputs/Button/Button.es.js";
import { COMPONENT_SIZE as O } from "../../../constants/sizes.es.js";
function f({
  activeTab: e,
  className: n,
  components: t = {},
  color: r = "primary",
  defaultActiveTab: P,
  isAnchoring: j = !1,
  isPage: E,
  onChange: h,
  options: s,
  size: b = O.md,
  updateHash: c = !0,
  withLine: F = !1
}) {
  const [a, g] = x(P || s[0].value), d = s.find((i) => i.value === a), [k, A] = x(!1);
  u(() => {
    a && !k && setTimeout(() => {
      A(!0);
    }, 2e3);
  }, [a]), u(() => {
    e && (g(e), c && (window.location.hash = e));
  }, [e]);
  const I = (i) => {
    g(i), c && (window.location.hash = i), h && h(i);
  };
  return u(() => () => {
    c && (window.location.hash = "");
  }, []), /* @__PURE__ */ v(G, { className: n, children: [
    /* @__PURE__ */ m(J, { className: "tab-buttons", children: s.map((i, q) => {
      const S = i, {
        value: p = "",
        label: L = "",
        disabled: M = !1,
        block: R = !1
      } = S, Z = N(S, [
        "value",
        "label",
        "disabled",
        "block"
      ]);
      return /* @__PURE__ */ m(K, { active: p === a, color: r, withLine: F, size: b, children: /* @__PURE__ */ m(U, C(B({ disabled: M, className: "tab-button", onClick: () => I(p), variant: "text", size: b, block: R, type: "button" }, Z), { children: L })) }, q.toString());
    }) }),
    /* @__PURE__ */ v(Q, { isPage: E, children: [
      (t == null ? void 0 : t.FirstContent) && /* @__PURE__ */ m(t.FirstContent, {}),
      j ? s.map((i) => i.children) : d == null ? void 0 : d.children
    ] })
  ] });
}
const V = {
  color: o.oneOf(["primary", "secondary"]),
  activeTab: o.string,
  components: o.shape({
    FirstContent: o.elementType
  }),
  selectedTab: o.string,
  defaultActiveTab: o.string,
  className: o.string,
  isAnchoring: o.bool,
  isPage: o.bool,
  onChange: o.func,
  options: o.array.isRequired,
  size: o.oneOf(Object.values(O)),
  updateHash: o.bool,
  withLine: o.bool
};
f.S = D;
f.displayName = "SegmentedButton";
f.propTypes = V;
//! migrate to new structure
export {
  f as SegmentedButton,
  V as segmentedButtonPropTypes
};
//# sourceMappingURL=SegmentedButton.es.js.map
